{
  "name": "identibase-front",
  "version": "1.2.40",
  "build": "637",
  "scripts": {
    "prebuild": "node set-version.js",
    "ng": "ng",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "start": "ng serve --configuration localDev",
    "start:petlog": "ng serve --configuration petlog-localDev",
    "start:ssr": "ng build --configuration localDev && npm run serve:ssr",
    "watch:ssr": "ng build --configuration localDev --watch",
    "serve:ssr": "node dist/identibase-front/server/server.mjs",
    "build:ssr": "ng build",
    "build:ssr:dev": "ng build --configuration development",
    "build:ssr:test": "ng build --configuration test",
    "build:ssr:test2": "ng build --configuration test2",
    "build:ssr:prod": "ng build --configuration production",
    "build:ssr:petlog-test": "ng build --configuration petlog-test",
    "build:ssr:petlog-prod": "ng build --configuration petlog-production",
    "rearrange-dist-folder": "mv dist/identibase-front/server/* dist/identibase-front/ && rm -r dist/identibase-front/server && mv dist/identibase-front/browser/Web.config dist/identibase-front/Web.config && { [ ! -f dist/identibase-front/3rdpartylicenses.txt ] || mv dist/identibase-front/3rdpartylicenses.txt dist/identibase-front/browser/; }"
  },
  "private": true,
  "dependencies": {
    "@abacritt/angularx-social-login": "2.3",
    "@angular/animations": "18.2.8",
    "@angular/cdk": "18.2.9",
    "@angular/common": "18.2.8",
    "@angular/compiler": "18.2.8",
    "@angular/core": "18.2.8",
    "@angular/forms": "18.2.8",
    "@angular/google-maps": "18.2.8",
    "@angular/localize": "18.2.8",
    "@angular/material": "18.2.9",
    "@angular/platform-browser": "18.2.8",
    "@angular/platform-browser-dynamic": "18.2.8",
    "@angular/platform-server": "18.2.8",
    "@angular/router": "18.2.8",
    "@angular/ssr": "18.2.9",
    "@auth0/angular-jwt": "5.2.0",
    "@azure/msal-angular": "4.0.21",
    "@azure/msal-browser": "4.26.1",
    "@cloudinary/ng": "2.1.5",
    "@cloudinary/transformation-builder-sdk": "1.17.0",
    "@cloudinary/url-gen": "1.21.0",
    "@fortawesome/angular-fontawesome": "0.15.0",
    "@fortawesome/fontawesome-svg-core": "6.5.2",
    "@fortawesome/free-brands-svg-icons": "6.5.2",
    "@fortawesome/free-regular-svg-icons": "6.5.2",
    "@fortawesome/free-solid-svg-icons": "6.5.2",
    "@iterable/web-sdk": "2.2.1",
    "@ng-bootstrap/ng-bootstrap": "17.0.1",
    "@popperjs/core": "2.11.8",
    "@zxcvbn-ts/core": "3.0.4",
    "@zxcvbn-ts/language-common": "3.0.4",
    "@zxcvbn-ts/language-en": "3.0.2",
    "angular-google-tag-manager": "1.10.0",
    "body-parser": "2.2.0",
    "classlist.js": "1.1.20150312",
    "cloudinary-core": "2.13.1",
    "compression": "1.8.2",
    "cookieconsent": "3.1.1",
    "core-js": "3.37.1",
    "cors": "2.8.5",
    "express": "4.18.2",
    "helmet": "8.3.0",
    "multer": "2.0.2",
    "ng2-file-upload": "7.0.1",
    "ngx-cookieconsent": "4.0.2",
    "ngx-image-cropper": "9.1.2",
    "rxjs": "7.5.0",
    "tslib": "2.6.3",
    "ua-parser-js": "1.0.37",
    "zone.js": "0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "18.2.9",
    "@angular-eslint/builder": "18.3.1",
    "@angular-eslint/eslint-plugin": "18.3.1",
    "@angular-eslint/eslint-plugin-template": "18.3.1",
    "@angular-eslint/schematics": "18.3.1",
    "@angular-eslint/template-parser": "18.3.1",
    "@angular/cli": "18.2.9",
    "@angular/compiler-cli": "18.2.8",
    "@angular/language-service": "18.2.8",
    "@types/compression": "1.7.5",
    "@types/express": "4.17.17",
    "@types/google.maps": "3.58.1",
    "@types/jasmine": "5.1.4",
    "@types/node": "20.11.25",
    "@typescript-eslint/eslint-plugin": "7.2.0",
    "@typescript-eslint/parser": "7.2.0",
    "bootstrap": "5.3.3",
    "eslint": "8.57.0",
    "eslint-config-prettier": "9.1.0",
    "eslint-plugin-import": "2.29.1",
    "eslint-plugin-jsdoc": "48.2.8",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "eslint-plugin-prettier": "5.1.3",
    "jasmine-core": "4.6.1",
    "jasmine-spec-reporter": "7.0.0",
    "karma": "6.4.3",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage-istanbul-reporter": "3.0.2",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "prettier": "3.3.1",
    "prettier-eslint": "16.3.0",
    "ts-node": "10.0.0",
    "typescript": "5.4"
  }
}
